import React, { Component } from 'react';
import merge from 'lodash/merge';
import PropTypes from 'prop-types';
import Api from 'lib/Api';

class Buy extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cartProducts: props.cartProducts,
      skus: props.skus,
    }
  }

  handleCart = (sku, e) => {
    sku.inCart ? this.removeFromCart(sku) : this.addToCart(sku);
  }

  addToCart = sku => {
    if (!sku.isAvailable) return;

    Api.post(_routes.addToCart, { product_id: sku.productId, sku_id: sku.skuId }).then(response => {
      this.updateSku(response.body, sku, true);
    });
  }

  removeFromCart = sku => {
    Api.put(_routes.removeFromCart, { product_id: sku.productId, sku_id: sku.skuId }).then(response => {
      this.updateSku(response.body, sku, false);
    });
  }

  updateSku(cartProducts, sku, inCart) {
    const newState = merge({}, this.state, { cartProducts });

    newState.skus.forEach(s => {
      if (s.productId == sku.productId && s.skuId == sku.skuId) {
        s.inCart = inCart;
      }
    })
    this.setState(newState);

    ShopBuy.updateCart(cartProducts);
  }

  render() {
    const orderReady = this.state.skus.filter(s => s.inCart === true).length > 0;

    return (
      <div className={`product-buy ${orderReady ? '-orderReady' : ''}`}>
        {this.state.skus.map(sku =>
          <div className={`product-sku ${sku.inCart ? '-inCart' : ''} ${sku.isAvailable ? '' : '-isUnavailable'}`} key={sku.skuId}>
            <label>
              <span className='product-skuIcon'>
                <button type="button" className={`btn-cart ${sku.inCart ? '-inCart' : ''} ${!sku.isAvailable ? '-disabled' : '' }`} onClick={(e) => this.handleCart(sku, e)}>{App.t('product.cart')}</button>
              </span>
              {sku.type}
              {sku.includedType ? ` + ${sku.includedType}` : null}
              {` - `}
              {sku.isAvailable ? `${sku.price}€` : <span className="product-unavailable">{App.t('product.unavailable')}</span>}
            </label>
          </div>
        )}
        <p className={`product-buyButton ${orderReady ? '-orderReady' : ''}`}>
          <a className="btn small -green" href={_routes.cart}>
            {App.t('product.order')}
          </a>
        </p>
      </div>
    );
  }

}

Buy.propTypes = {
  cartProducts: PropTypes.array.isRequired,
  skus:         PropTypes.array.isRequired,
};

export default Buy;
